import { ShipmentTrackingRecordsActionTypes } from './constants';

type ShipmentTrackingRecordsAction = { type: string, payload: {} | string };

export const shipmentTrackingRecordsApiResponseSuccess = (actionType: string, data: any): ShipmentTrackingRecordsAction => ({
    type: ShipmentTrackingRecordsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const shipmentTrackingRecordsApiResponseError = (actionType: string, error: string): ShipmentTrackingRecordsAction => ({
    type: ShipmentTrackingRecordsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const processTrackingRecords = (query): ShipmentTrackingRecordsAction => ({
    type: ShipmentTrackingRecordsActionTypes.PROCESS_TRACKING_RECORDS,
    payload: { query },
});

export const shipmentTrackingRecordsResetState = (): ShipmentTrackingRecordsAction => ({
    type: ShipmentTrackingRecordsActionTypes.RESET_STATE,
    payload: {},
});
